export namespace DELIVERY_NETWORKS {
  export const Z = "Z";
  export const Caltex = "Caltex";
  export const Challenge = "Challenge";
}

export namespace SITE_TYPES {
  export const ServiceStation = "ServiceStation";
  export const TruckStop = "TruckStop";
}

export const deliveryNetworks = [
  DELIVERY_NETWORKS.Z,
  DELIVERY_NETWORKS.Caltex,
  DELIVERY_NETWORKS.Challenge
];

export const siteTypes = [
  SITE_TYPES.ServiceStation,
  SITE_TYPES.TruckStop
];
